import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC, useCallback, useMemo } from 'react'
import { LoadingSpinner } from '../../../utils/loading-spinner'
import { MergedStoreCategoryCard } from '../CategoryCard/CategoryCard'
import { parseCategoriesListResponse } from './CategoriesList.utils'
import { useFetchCategoriesList } from './CategoriesList.hooks'
import InfiniteScroll from 'react-infinite-scroll-component'
import Skeleton from 'react-loading-skeleton'

export const CategoriesList: FC = () => {
  const {
    data,
    error,
    size = 0,
    setSize
  } = useFetchCategoriesList({
    limit: 20,
    excludeChildCategories: true
  })
  const handleLoadMore = useCallback(() => setSize(size + 1), [size, setSize])
  const { categories, pageInfo } = useMemo(() => parseCategoriesListResponse(data), [data])
  const isLoading = !data && !error

  return (
    <Box
      backgroundColor="secondary.backgroundLight"
      padding={{ _: 0, md: '5px 0', lg: '10px 0', xl: '20px 0' }}
    >
      <Box
        maxWidth={{ _: '100%', md: '686px', lg: '1202px' }}
        width="100%"
        margin="0 auto"
        display={'block'}
      >
        {isLoading ? (
          <div data-testid="loader">
            <Skeleton height={'298px'} width="100%" />
          </div>
        ) : (
          <InfiniteScroll
            next={handleLoadMore}
            dataLength={categories?.length || 0}
            hasMore={Boolean(pageInfo?.hasNextPage)}
            loader={
              <Box justifyContent={'center'}>
                <LoadingSpinner />
              </Box>
            }
            scrollableTarget={'categories-list'}
          >
            <Box
              display="grid"
              gridTemplateColumns={{
                _: 'repeat(auto, 1fr)',
                md: 'repeat(2, 1fr)',
                lg: 'repeat(4, 1fr)'
              }}
              gridColumnGap={{
                _: 0,
                md: '30px',
                lg: '34px'
              }}
              gridRowGap={{ _: '20px', md: '25px', lg: '30px' }}
              padding={{ _: '40px 54px', md: '40px 40px' }}
            >
              {categories?.map(category => (
                <MergedStoreCategoryCard
                  cardImageUrl={category?.tileImageUrl}
                  cardTitle={category?.name}
                  description={category?.description}
                  key={category?.id}
                  id={category?.id}
                />
              ))}
            </Box>
          </InfiniteScroll>
        )}
      </Box>
    </Box>
  )
}
